import axios from "axios";
import { adalConfig } from "../../common/endpoints";

// API function to fetch user projects
export const fetchOfferTypeDetails = async (tenantId: string, objectId: string) => {
  try {
    const offerLimit = 100;
    const response = await axios.get(
      adalConfig?.endpoints?.getOfferDetails + `tenantId=${tenantId}&objectId=${objectId}${offerLimit ? `&offerLimit=${offerLimit}` : ''}`
    );
    return response.data;
  } catch (error: any) {
    throw new Error(error?.response?.data?.message || "Something went wrong");
  }
};
